export default "__VITE_ASSET__CZtHBqKd__"